<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area foot">
      <div class="tit_area">
        <div class="sub_tit">오시는 길</div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="flex_box">
        <h3 class="gap">판교본사</h3>
        <a
          href="https://map.naver.com/v5/directions/-/14150052.854170006,4493999.631056396,%EA%B2%BD%EA%B8%B0%EB%8F%84%20%EC%84%B1%EB%82%A8%EC%8B%9C%20%EB%B6%84%EB%8B%B9%EA%B5%AC%20%ED%8C%90%EA%B5%90%EC%97%AD%EB%A1%9C146%EB%B2%88%EA%B8%B8%2020,,/-/transit?c=14149989.5133797,4493993.9003861,18,0,0,0,dh"
          target="_blank"
          rel="noreferrer noopener"
          class="btn_blue"
          >길찾기</a
        >
      </div>
      <div class="map_box" id="map_hp"></div>
      <div class="map_info">
        <dl>
          <dt>주소</dt>
          <dd>
            경기도 성남시 분당구 판교역로 146번길 20<br />현대백화점 오피스H
            13층
          </dd>
          <dt>전화</dt>
          <dd>031-5171-0700</dd>
          <dt>FAX</dt>
          <dd>031-951-1300</dd>
        </dl>
      </div>
      <div class="flex_box mgt50">
        <h3 class="gap">아산공장</h3>
        <a
          href="https://map.naver.com/v5/directions/-/14134561.923261885,4421649.570864994,,,/-/transit?c=14134385.7601677,4421574.6206152,17,0,0,0,dh"
          target="_blank"
          rel="noreferrer noopener"
          class="btn_blue"
          >길찾기</a
        >
      </div>
      <div class="map_box" id="map_factory1"></div>
      <div class="map_info">
        <dl>
          <dt>주소</dt>
          <dd>충청남도 아산시 영인면 토정샘로 66</dd>
          <dt>전화</dt>
          <dd>041-544-0155</dd>
          <dt>FAX</dt>
          <dd>041-541-5369</dd>
        </dl>
      </div>
      <div class="flex_box mgt50">
        <h3 class="gap">음성공장</h3>
        <a
          href="https://map.naver.com/v5/directions/-/14213138.163601149,4455101.141058747,%ED%95%9C%EC%84%B1%ED%94%BC%EC%94%A8%EA%B1%B4%EC%84%A4%20%EC%9D%8C%EC%84%B1%EA%B3%B5%EC%9E%A5,37240203,PLACE_POI/-/transit?c=14213079.3895089,4455110.9393197,18,0,0,0,dh"
          target="_blank"
          rel="noreferrer noopener"
          class="btn_blue"
          >길찾기</a
        >
      </div>
      <div class="map_box" id="map_factory2"></div>
      <div class="map_info">
        <dl>
          <dt>주소</dt>
          <dd>충청북도 음성군 감곡면 가곡로 335</dd>
          <dt>전화</dt>
          <dd>043-927-0790</dd>
          <dt>FAX</dt>
          <dd>043-901-0023</dd>
        </dl>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
import maps from '@/maps';

export default {
  mixins: [page],
  mounted() {
    maps.init();
  }
};
</script>

<style lang="scss" scoped>
#map_factory1 {
  width: 100%;
  height: 200rem;
  border: 1px solid #ddd;
}

#map_factory2 {
  width: 100%;
  height: 200rem;
  border: 1px solid #ddd;
}
</style>
